import { PropsWithChildren, useState } from "react";
import { createStore } from "zustand";

import { MatchesStoreType } from "./matches_store.types";
import { getInitialMatchesState, MatchesStoreContext } from "./matches_store_context";

export const MatchesStoreProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(() =>
    createStore<MatchesStoreType>()((set) => {
      const initialState = getInitialMatchesState();

      return {
        ...initialState,
        actions: {
          updateMatchesParams: (params) =>
            set((state) => ({
              matchesParams: {
                ...state.matchesParams,
                ...params
              }
            })),
          setMatchesParams: (matchesParams) => set({ matchesParams }),
          resetMatchesParams: () => set({ matchesParams: getInitialMatchesState().matchesParams })
        }
      };
    })
  );

  return <MatchesStoreContext.Provider value={store}>{children}</MatchesStoreContext.Provider>;
};
